import {type UISidebarController} from '../../../ui_html/sidebar/UISidebarController.ts'

export class UIDGiftingSceneController {
    private readonly sidebarController: UISidebarController
    private readonly giftingSceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.giftingSceneContainerDiv = document.getElementById('scene_discord_gifting_container') as HTMLDivElement
    }

    hide() {
        this.giftingSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.giftingSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
